export enum CompanyType {
  Hosting = 1,
  Customer = 2
}

export interface Company {
  companyId: number;
  companyType: CompanyType;
  companyName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  city: string;
  postCode: string;
  isActive: boolean;
  createdDate: string;
  userCount: number;
  activeUserCount: number;
  deviceCount: number;
}

export interface CreateHostingCompanyRequest {
  companyName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  city: string;
  postCode: string;
  adminFirstName: string;
  adminLastName: string;
  adminEmail: string;
  adminPassword: string;
}